@if (form.controls.length > 0) {
  <h1>Külső azonosítók</h1>
}
@for (externalId of form.controls; track externalId.controls.type.value) {
  <payee-form-field width="wide">
    <input
      payee-input
      [formControl]="externalId.controls.value"
    />
    <span payee-label>
      {{ externalIdTypeDisplayWith(externalId.controls.type.value) }}
    </span>
    @if (externalId.controls.value.value) {
      <button
        payee-suffix
        payee-icon-button
        type="button"
        color="custom"
        aria-label="Törlés"
        (mousedown)="clearExternalId($event, externalId)"
      >
        <payee-icon
          name="cross-black"
          width="16"
          height="16"
        ></payee-icon>
      </button>
    }
  </payee-form-field>
}
